<template>
  <v-container id="bues" fluid tag="section">
    <div class="text-right">
      <v-btn
        color="cyan"
        class="mr-2"
        small
        v-if="showGrid"
        @click="showFilter = !showFilter"
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        class="mr-0"
        small
        v-if="singlePage && !showGrid"
        @click="
          showGrid = !showGrid;
          entity_id = null;
        "
      >
        <v-icon v-if="showGrid">mdi-plus</v-icon>
        <v-icon v-if="!showGrid">mdi-grid</v-icon>
        {{ $i18n.t("All") }}
      </v-btn>

      <v-menu offset-y v-if="showGrid">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/entity/create'" v-if="!singlePage">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="singlePage"
            @click="
              showGrid = !showGrid;
              entity_id = null;
            "
          >
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>{{ $i18n.t("Upload") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <entity-edit
      v-if="!showGrid"
      :entity_id="entity_id"
      :singlePage="singlePage"
      @select="select"
      :forClient="forClient"
    />

    <v-row justify="center" v-if="showFilter && showGrid">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="name"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('GSTIN')"
                class="purple-input"
                v-model="gstin"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Invoice Prefix')"
                class="purple-input"
                v-model="invoicePrefix"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Invoice Prefix SEZ')"
                class="purple-input"
                v-model="invoicePrefixSEZ"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Invoice Email')"
                class="purple-input"
                v-model="invoiceEmail"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Invoice Phone')"
                class="purple-input"
                v-model="invoicePhone"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Short Code')"
                class="purple-input"
                v-model="shortCode"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-country-select
                :label="$i18n.t('Country')"
                class="purple-input"
                v-model="country"
              ></z-country-select>
            </v-col>

            <v-col cols="12" md="2">
              <z-state-select
                :label="$i18n.t('State')"
                class="purple-input"
                v-model="state"
                :country="country"
              ></z-state-select>
            </v-col>

            <v-col cols="12" md="2">
              <z-city-select
                :label="$i18n.t('City')"
                class="purple-input"
                v-model="city"
                :state="state"
                :country="country"
              ></z-city-select>
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="showGrid && grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Entity')"
      class="px-5 py-3"
      v-if="showGrid && grid.records"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("Entity") }}</th>
            <th class="primary--text">{{ $i18n.t("GSTIN") }}</th>
            <th class="primary--text">{{ $i18n.t("RCM") }}</th>
            <th class="primary--text">{{ $i18n.t("SEZ") }}</th>
            <th class="primary--text">{{ $i18n.t("Prefix") }}</th>
            <th class="primary--text">
              {{ $i18n.t("Reset Invoice") }}
            </th>

            <th class="primary--text">{{ $i18n.t("Address") }}</th>
            <th class="primary--text">{{ $i18n.t("Contact Person") }}</th>
            <th class="primary--text">{{ $i18n.t("Details") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <entity-row
          v-for="bu in grid.rows"
          :key="bu._id"
          :value="bu"
          :singlePage="singlePage"
          :showSelectBtn="showSelectBtn"
        />
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import EntityRow from "@/views/entity/EntityRow.vue";
import EntityEdit from "@/views/entity/EntityEdit.vue";

@Component({
  components: {
    EntityEdit,
    EntityRow,
  },
  props: {
    singlePage: {
      default: false,
    },
    showGrid1: {
      default: true,
    },
    forClient: {
      default: null,
    },
    showSelectBtn: {
      default: false,
    },
  },
})
export default class Entity extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/entity/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  state = "";
  gstin = "";
  invoicePrefix = "";
  invoiceEmail = "";
  invoicePrefixSEZ = "";
  shortCode = "";
  invoicePhone = "";
  showGrid = true;
  entity_id = null;
  corp_id = null;

  get loading() {
    return common.loading;
  }

  entityEdit(_id) {
    //This is used for single page application
    this.entity_id = _id;
    this.showGrid = false;
  }

  select(data) {
    this.$emit("select", data);
    this.showGrid = true;
    this.clear();
  }

  async mounted() {
    this.showGrid = this.showGrid1;
    if (this.forClient) this.corp_id = this.forClient;
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url + "&corp_id=" + this.corp_id);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(
      this.url + this.filterUrl + "&page=" + page + "&corp_id=" + this.corp_id
    );
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.gstin = "";
    this.invoicePrefix = "";
    this.invoicePrefixSEZ = "";
    this.invoiceEmail = "";
    this.invoicePhone = "";
    this.shortCode = "";
    this.country = "";
    this.state = "";
    this.city = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.gstin) this.filterUrl += "&gstin=" + this.name;
    if (this.invoicePrefix)
      this.filterUrl += "&invoicePrefix=" + this.invoicePrefix;
    if (this.invoicePrefixSEZ)
      this.filterUrl += "&invoicePrefixSEZ=" + this.invoicePrefixSEZ;
    if (this.invoiceEmail)
      this.filterUrl += "&invoiceEmail=" + this.invoiceEmail;
    if (this.invoicePhone)
      this.filterUrl += "&invoicePhone=" + this.invoicePhone;
    if (this.shortCode) this.filterUrl += "&shortCode=" + this.shortCode;
    if (this.country) this.filterUrl += "&country=" + this.country;
    if (this.state) this.filterUrl += "&state=" + this.state;
    if (this.city) this.filterUrl += "&city=" + this.city;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deletebu(bu) {
    try {
      await doGet("/api/entity/" + bu._id + "/delete/entity");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async makePrimary(bu) {
    try {
      await doGet("/api/entity/" + bu._id + "/primary/entity");
      common.showMessage("Successfully done");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
